/* Tribes theme layer: night/light switch, monthly/yearly prices, "coming soon" links. */
(() => {
  const KEY = 'tr-theme';
  const root = document.documentElement;
  const store = { get() { try { return localStorage.getItem(KEY); } catch (e) { return null; } }, set(v) { try { localStorage.setItem(KEY, v); } catch (e) { /* private mode */ } } };

  const label = () => {
    const light = root.getAttribute('data-tr-theme') === 'light';
    document.querySelectorAll('[data-tr-toggle]').forEach((b) => {
      b.setAttribute('aria-label', light ? b.dataset.labelDark : b.dataset.labelLight);
      b.setAttribute('aria-pressed', String(light));
    });
  };

  // follow the system setting until the visitor picks a mode themselves
  const mq = matchMedia('(prefers-color-scheme: light)');
  mq.addEventListener?.('change', (e) => {
    if (store.get() || root.dataset.trDefault !== 'system') return;
    root.setAttribute('data-tr-theme', e.matches ? 'light' : 'dark'); label();
  });

  let tt;
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-tr-toggle]');
    if (t) {
      const next = root.getAttribute('data-tr-theme') === 'light' ? 'dark' : 'light';
      root.setAttribute('data-tr-theme', next); store.set(next); label();
      return;
    }
    const b = e.target.closest('[data-tr-bill]');
    if (b) {
      const sec = b.closest('[data-tr-plans]');
      let plans; try { plans = JSON.parse(sec.dataset.trPlans); } catch (err) { return; }
      const p = plans[b.dataset.trBill];
      sec.querySelector('[data-tr-price]').textContent = p.price;
      sec.querySelector('[data-tr-per]').textContent = p.per;
      sec.querySelectorAll('[data-tr-bill]').forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
      return;
    }
    const a = e.target.closest('a[data-soon]');
    if (a) {
      e.preventDefault();
      const toast = document.querySelector('[data-tr-toast]');
      if (!toast) return;
      toast.textContent = a.dataset.soon; toast.hidden = false;
      clearTimeout(tt); tt = setTimeout(() => { toast.hidden = true; }, 3600);
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', label); else label();
  document.addEventListener('shopify:section:load', label);
})();
